export enum ArrowIcons {
	OnBoarding = 'on-boarding-arrow',
	Filled = 'arrow-filled',
}

export enum ArrowDirection {
	Up = 'up',
	Down = 'down',
	Left = 'left',
	Right = 'right',
}
